import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["pending", "status", "files", "message", "retry"]

  connect() {
    this.pending = this.data.get("pending") === "true"
    this.disconnected = false
    this.schedule()
  }

  disconnect() {
    this.disconnected = true
    clearTimeout(this.timeout)
    if (this.request) this.request.abort()
  }

  async generate(event) {
    event.preventDefault()
    if (this.pending || this.fetching || this.unknown) return

    const form = event.target
    const csrf = document.querySelector("meta[name='csrf-token']")
    this.setMessage("Ieplāno diplomu ģenerēšanu…")
    await this.load(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: csrf ? { "X-CSRF-Token": csrf.content } : {}
    })
  }

  retry(event) {
    event.preventDefault()
    this.refresh()
  }

  refresh() {
    return this.load(this.data.get("statusUrl"))
  }

  async load(url, options = {}) {
    if (this.fetching || this.disconnected) return
    clearTimeout(this.timeout)
    this.fetching = true
    this.request = new AbortController()
    this.disableButtons(true)
    this.retryTarget.hidden = true

    try {
      const response = await fetch(url, {
        ...options,
        headers: { ...options.headers, "Accept": "application/json" },
        credentials: "same-origin",
        cache: "no-store",
        signal: this.request.signal
      })
      if (response.redirected || (!response.ok && response.status !== 409)) throw new Error("Status unavailable")
      const data = await response.json()
      if (typeof data.pending !== "boolean" || typeof data.status_html !== "string" || (!data.pending && typeof data.files_html !== "string")) {
        throw new Error("Invalid status")
      }
      if (this.disconnected) return
      this.pending = data.pending
      this.unknown = false
      const focusedButton = Array.from(this.filesTarget.querySelectorAll("button")).indexOf(document.activeElement)
      if (this.statusTarget.innerHTML !== data.status_html) this.statusTarget.innerHTML = data.status_html
      if (!this.pending) this.filesTarget.innerHTML = data.files_html
      this.setMessage(this.pending ? "Diplomi tiek ģenerēti. Statuss atjaunosies automātiski." : "")
      this.disableButtons(this.pending)
      if (focusedButton >= 0) {
        const button = this.filesTarget.querySelectorAll("button")[focusedButton]
        const focusTarget = button && !button.disabled ? button : this.statusTarget
        focusTarget.focus({ preventScroll: true })
      }
    } catch (error) {
      if (error.name === "AbortError" || this.disconnected) return
      this.unknown = true
      this.setMessage("Neizdevās pārbaudīt diplomu statusu. Pārbaudi savienojumu un mēģini vēlreiz.", true)
      this.retryTarget.hidden = false
    } finally {
      this.fetching = false
      if (!this.disconnected) {
        this.disableButtons(this.pending || this.unknown)
        this.schedule()
      }
    }
  }

  setMessage(message, error = false) {
    this.messageTarget.textContent = message
    this.messageTarget.hidden = !message
    this.messageTarget.setAttribute("role", error ? "alert" : "status")
  }

  disableButtons(disabled) {
    this.filesTarget.querySelectorAll("button").forEach(button => { button.disabled = disabled })
    this.filesTarget.setAttribute("aria-busy", (this.pending || this.fetching).toString())
  }

  schedule() {
    clearTimeout(this.timeout)
    if (this.pending && !this.unknown && !this.disconnected) {
      this.timeout = setTimeout(() => this.refresh(), this.refreshInterval)
    }
  }

  get refreshInterval() {
    return Number(this.data.get("refreshInterval")) || 5000
  }
}
